<template>
  <v-card class="mx-auto" flat>
    <v-toolbar color="secondary" dark flat>
      <v-toolbar-title>{{ subtitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-alert v-if="deskripsi" text type="info" dense>
        <div v-html="deskripsi"></div>
      </v-alert>
      <base-form-generator :schema="schema['total']" v-model="form" />
      <template v-for="(p, i) in form.deskripsi || []">
        <v-row no-gutters dense :key="i">
          <v-col cols="12" md="10" sm="12">
            <base-form-generator :schema="schema['pengalaman']" v-model="form[i]" />
          </v-col>
          <v-col cols="12" md="2" sm="12" class="my-auto">
            <div class="text-right" v-if="Number(i) !== 0">
              <v-btn title="Hapus" small depressed rounded color="grey" dark class="mx-2" @click="remove(i)">
                <v-icon left v-text="'mdi-close'"></v-icon> hapus
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <v-divider></v-divider>
      <v-btn
        depressed
        :color="this.max === (form.deskripsi || []).length ? '' : 'primary'"
        :class="this.max === (form.deskripsi || []).length ? 'grey--text mt-3' : 'mt-3'"
        @click="add"
      >
        Tambah {{ subtitle }} Lain
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'InformasiDasar',
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: '',
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    mFungsi: {
      type: Object,
      default: () => {},
    },
    configs: {
      type: Object,
      default: () => {},
    },
    kSumber: {
      type: Number,
      default: null,
    },
    deskripsi: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {},
      pengalamans: [],
      limit: 3,
    };
  },
  computed: {
    schema() {
      return {
        total: [
          {
            type: 'VSelect',
            name: 'pilihan',
            label: 'Berapa lama total pengalaman mengajar virtual/daring Anda?',
            labelColor: 'info',
            placholder: 'Pilih lama pengalaman mengajar virtual/daring',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters['lama_ajar']),
            itemText: 'text',
            itemValue: 'value',
            required: true,
            hideDetails: true,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            class: 'pt-0',
          },
        ],
        pengalaman: [
          {
            type: 'VTextField',
            name: 'deskripsi',
            label: 'Pengalaman memfasilitasi kelas Daring dan Luring',
            labelColor: 'info',
            placholder: 'Tuliskan pengalaman memfasilitasi kelas Daring dan Luring',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
        ],
      };
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },
    add() {
      if (this.form.deskripsi.length === this.max) {
        this.$error(`Maksimal ${this.max} data ${this.subtitle}.`);
        return;
      }

      this.form.deskripsi.push({ deskripsi: '' });
    },
    remove(id) {
      delete this.form[id];
      this.form.deskripsi.splice(id, 1);
    },
    initForm(value) {
      this.$set(this.form, 'pilihan', (value && value.pilihan) || '');
      for (const p in (value && value.deskripsi) || []) {
        this.$set(this.form, 'deskripsi', []);
        this.$set(this.form['deskripsi'], p, this.$getDeepObj(value, `deskripsi.${p}.deskripsi`) || '');
        this.$set(this.form, p, {});
        this.$set(this.form[p], 'deskripsi', this.$getDeepObj(value, `deskripsi.${p}.deskripsi`) || '');
      }
    },
    getValue() {
      return this.form;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped></style>
